import React from "react";
import { motion } from "framer-motion";
import checkIcon from "../Images/check-icon.png";

const AboutService = ({
  title,
  desc,
  points = [],
  isLongHeading = false,
}) => {

  // FADE UP
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // POINT CARD
  const pointVariant = {
    hidden: {
      opacity: 0,
      x: 20,
    },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.08,
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };

  return (
    <>
      <motion.section
        className="about-service-section container"
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.15,
        }}
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.12,
            },
          },
        }}
      >

        {/* LEFT */}

        <motion.div
          className="about-service-left"
          variants={fadeUp}
        >

       <h2
  className={`section-heading ${
    isLongHeading ? "long-heading" : ""
  }`}
>
  {title}
</h2>
          <p className="section-text">
            {desc}
          </p>

        </motion.div>

        {/* RIGHT */}

        <motion.div
          className="about-service-right"
          variants={fadeUp}
        >

          <h3 className="card-heading">
            We handle settlements for:
          </h3>

          <div className="about-service-points">

            {points.map((item, index) => (

              <motion.div
                className="about-service-point"
                key={index}
                custom={index}
                variants={pointVariant}
                whileHover={{
                  x: 6,
                }}
                transition={{
                  duration: 0.25,
                }}
              >

                <motion.img
                  src={checkIcon}
                  alt={`${item} | LDL Settlement Services`}
                  whileHover={{
                    scale: 1.08,
                    rotate: -3,
                  }}
                  transition={{
                    duration: 0.3,
                  }}
                />

                <p className="section-text">
                  {item}
                </p>

              </motion.div>

            ))}

          </div>

        </motion.div>

      </motion.section>
    </>
  );
};

export default AboutService;